import React from 'react'
import './Styles.css'
const SideBarCard = ({name}) => {
  return (
    <div  className='side-bar-card-container'>
          {name}
    </div>
  )
}

export default SideBarCard
